import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/periodicidad-de-percepciones';

/**
 * GET Periodicidad de Percepciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getPeriodicidadDePercepciones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Periodicidad de Percepcion
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPeriodicidadDePercepcion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Periodicidad de Percepcion
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPeriodicidadDePercepcion = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Periodicidad de Percepcion
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPeriodicidadDePercepcion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Periodicidad de Percepcion
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePeriodicidadDePercepcion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
